import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'InsuranceCompany', method: 'GET', token: token })
}
